module.exports = __webpack_public_path__ + "img/7-whale_v8e.e20142c8.png";